export const recommendDataCity = {
  //获取酒店首页推荐酒店、商圈、品牌数据
  module: 'hotel-front-api',
  method: 'POST',
  address: 'hotel-home/recommend-data-city',
};
export const HotelSearch = {
  // 散房酒店列表搜索
  module: 'b2b',
  method: 'POST',
  address: 'Hotel/Search',
};
export const GetTravelStandardRewardRule = {
  // 获取节省奖励规则
  module: 'b2b',
  method: 'POST',
  address: 'Hotel/GetTravelStandardRewardRule',
};
export const GetBetterRoomList = {
  // 获取节省奖励房型pk
  module: 'hotel',
  method: 'POST',
  address: 'api/hotel/info/GetBetterRoomList',
};
